import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { listMySubmissions, MySubmissionSummary } from "../api/mySubmissions";

export default function MySubmissionsPage() {
  const [rows, setRows] = useState<MySubmissionSummary[]>([]);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    listMySubmissions()
      .then(setRows)
      .catch((e) => setError(e instanceof Error ? e.message : "Failed to load"))
      .finally(() => setLoading(false));
  }, []);

  return (
    <div className="container">
      <div className="page-header">
        <h1>My submissions</h1>
        <Link to="/" className="btn-secondary">← Back to form</Link>
      </div>
      {error && <div className="banner-error">{error}</div>}
      {loading && <p className="hint">Loading…</p>}
      {!loading && rows.length === 0 && !error && (
        <p className="hint">You haven't submitted any projects yet.</p>
      )}
      {rows.length > 0 && (
        <div className="admin-table-wrap">
          <table className="admin-table compact">
            <thead>
              <tr>
                <th>Project</th>
                <th>Job #</th>
                <th>Submitted</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => {
                const projectName = (r.data?.projectName as string) || "(untitled)";
                const jobNumber = (r.data?.jobNumber as string) || "";
                return (
                  <tr key={r.id} className="row-clickable">
                    <td>
                      <Link className="row-action" to={`/submissions/${r.id}`}>{projectName}</Link>
                    </td>
                    <td>{jobNumber}</td>
                    <td>{new Date(r.submittedAt).toLocaleDateString()}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
